import { render, staticRenderFns } from "./MedhopDataTable.vue?vue&type=template&id=23881286"
import script from "./MedhopDataTable.vue?vue&type=script&lang=js"
export * from "./MedhopDataTable.vue?vue&type=script&lang=js"
import style0 from "./MedhopDataTable.vue?vue&type=style&index=0&id=23881286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports